module.exports = __webpack_public_path__ + "static/media/preview_general_campaign_4.3522e252.svg";